import { useContext } from "react"
import GameContext from "../../../Context/GameContext"

export const useTurn = () => {
  const { gameData, gameState, gameProps } = useContext(GameContext)
  const roundIndex = gameState?.roundIndex

  if (!(Number.isInteger(roundIndex) || roundIndex < 0))
    return { error: "Incorrect round-index" }
  const roundData = gameData?.rounds[roundIndex]
  if (!roundData) return { error: "round-data not found" }

  const turnIndex = gameState?.turnIndex
  if (!(Number.isInteger(turnIndex) || turnIndex < 0))
    return { error: "Incorrect turn-index" }
  const turnData = roundData?.turns[turnIndex]
  if (!turnData) return { error: "turn-data not found" }

  const labels = {
    turn_player_draws_card:
      gameData?.game_defaults?.turn_player_draws_card || "",
    turn_player_reads_card:
      gameData?.game_defaults?.turn_player_reads_card || "",
  }

  const showPreviewTurn = turnData?.turn_show_impact_preview || false

  return {
    roundData,
    turnData,
    labels,
    gameProps,
    showPreviewTurn,
  }
}
